import React, { Component } from 'react';
import {
  Route,
  Switch,
  withRouter,
  BrowserRouter,
} from 'react-router-dom';
import Analytics from 'react-router-ga';
import getLocale from 'browser-locale';

import {
  HomePage,
  IntroPage,
  TeamPage,
  CasePage,
  CaseDetailPage,
  MethodPage,
  ContactPage,
  NoMatchPage,
} from './pages';

import DataPage from './DataPage';

// import '../../node_modules/bootstrap-sass/assets/stylesheets/bootstrap.scss';
import './app.css';

let locale = getLocale().replace(/-\S*/g, '');

const localeList = [
  'en-US',
  'zh-Hant-TW',
];

const pageRender = (Page) => {
  return withRouter((props) => {
    locale = props.match.params.locale || locale;
    const localeCode = localeList.find(item => item.slice(0, 2) === locale);
    return (
      <Page {...{
        ...props,
        locale,
        localeCode
      }}
      />
    );
  });
};

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Analytics id="UA-118350989-2">
          <div className="app">
            <Switch>
              {/* 公司簡介 */}
              <Route exact path="/:locale?/intro" render={pageRender(IntroPage)} />

              {/* 專業團隊 */}
              <Route exact path="/:locale?/team" render={pageRender(TeamPage)} />

              {/* 工程實績 */}
              <Route exact path="/:locale?/case" render={pageRender(CasePage)} />

              {/* 工程實績內頁 */}
              <Route exact path="/:locale?/case/:id" render={pageRender(CaseDetailPage)} />

              {/* 工法介紹 */}
              <Route exact path="/:locale?/method/:method" render={pageRender(MethodPage)} />

              {/* 聯絡我們 */}
              <Route exact path="/:locale?/contact" render={pageRender(ContactPage)} />

              <Route exact path="/data-page" component={DataPage} />

              <Route exact path="/:locale?" render={pageRender(HomePage)} />

              {/* 找不到頁面 */}
              <Route path="*" render={pageRender(NoMatchPage)}/>
            </Switch>
          </div>
        </Analytics>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js